/* eslint-disable no-restricted-globals */
/* CacheBuster component */
import React from "react";
import packageJson from "../package.json";
global.appVersion = packageJson.version;

// version from `meta.json` - first param
// version in bundle file - second param
const semverGreaterThan = (versionA, versionB) => {
  const versionsA = versionA.split(/\./g);

  const versionsB = versionB.split(/\./g);
  while (versionsA.length || versionsB.length) {
    const a = Number(versionsA.shift());

    const b = Number(versionsB.shift());
    // eslint-disable-next-line no-continue
    if (a === b) continue;
    // eslint-disable-next-line no-restricted-globals
    return a > b || isNaN(b);
  }
  return false;
};

export default class CacheBuster extends React.Component {
  constructor(props) {
    super(props);
    this.versionCheckingInterval = null;
    this.onCancelUpdateEventListener = null;
    this.state = {
      loading: true,
      isLatestVersion: false,
      refreshCacheAndReload: () => {
        console.log("Clearing cache and hard reloading...");
        if (caches) {
          // Service worker cache should be cleared with caches.delete()
          // delete browser cache and hard reload
          if ("serviceWorker" in navigator) {
            return navigator.serviceWorker.ready.then((registration) => {
              // Notifying user to reload app
              const pushUpdateEvent = new CustomEvent("push-app-update", {
                detail: { registration },
              });
              self.dispatchEvent(pushUpdateEvent);
            });
          } else {
            caches.keys().then(function (names) {
              for (let name of names) caches.delete(name);
            });
          }
        }
        window.location.reload();
      },
    };
  }

  componentDidMount() {
    this.onCancelUpdateEventListener = self.addEventListener("onCancelUpdate", () => {
      this.versionCheckingInterval && clearInterval(this.versionCheckingInterval);
      this.setState({ loading: false, isLatestVersion: true });
    });
    this.versionCheckingInterval = setInterval(
      () =>
        fetch("/meta.json")
          .then((response) => response.json())
          .then((meta) => {
            const latestVersion = meta.version;
            const currentVersion = global.appVersion;

            const shouldForceRefresh = semverGreaterThan(latestVersion, currentVersion);
            if (shouldForceRefresh) {
              console.log(`We have a new version - ${latestVersion}. Should force refresh`);
              this.setState({ loading: false, isLatestVersion: false });
            } else {
              console.log(
                `You already have the latest version - ${latestVersion}. No cache refresh needed.`
              );
              this.setState({ loading: false, isLatestVersion: true });
            }
          })
          .catch((err) => console.log(err)),
      2500
    );
  }

  componentWillUnmount() {
    clearInterval(this.versionCheckingInterval);
    self.removeEventListener("onCancelUpdate", this.onCancelUpdateEventListener);
  }

  render() {
    const { loading, isLatestVersion, refreshCacheAndReload } = this.state;
    return this.props.children({ loading, isLatestVersion, refreshCacheAndReload });
  }
}
